import { Injectable } from '@angular/core'
import { Store } from '@ngrx/store'
import { AccessFeature, canAccess } from '@sauna-net/dto'
import { combineLatest, distinctUntilChanged, map, Observable } from 'rxjs'
import { AppState } from '../../core/reducers'
import { accessConfig$ } from './access-config'

/** Přístup přihlášeného uživatele k funkcím z `ACCESS_FEATURES`; stejné pravidlo vyhodnocuje server přes `@RequireAccess`. */
@Injectable({
  providedIn: 'root',
})
export class AccessService {
  constructor(private readonly store: Store<AppState>) {}

  can$(feature: AccessFeature): Observable<boolean> {
    return combineLatest([this.store.select('auth'), accessConfig$]).pipe(
      map(([auth, config]) => canAccess(auth.user, feature, config)),
      distinctUntilChanged(),
    )
  }
}
